import { useNavigate, useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH, USER_TYPE } from "../../constant/reportType";
import { Switch, Table } from "antd";
import { LIBRARY_CATEGORY_COLUMN } from "../../constant/AppConstant";
import { BsFileEarmarkPdf, BsPencilSquare, BsPlus, BsSearch, BsTrash, BsUpload, BsZoomIn, BsZoomOut } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useDeleteLibraryCategoryByIdMutation, useGetAllLibraryCategoriesMutation, useGetAllLibraryCategoriesWithSearchMutation } from "../../redux-toolkit/services/libraryCategoriesService";
import { getLibraryCategoriesDetails, getLibraryCategoriesTotalRecords, setLibraryCategories, setLibraryCategoriesBySearch } from "../../redux-toolkit/slices/libraryCategorySlice";
import PrivateLibraryData from "./PrivateLibraryData";
import { useDeletePdfMutation, useGetLibraryByCategoryIdMutation } from "../../redux-toolkit/services/privateLibraryService";
import { getPrivateLibraryDetails, getPrivateLibraryTotalRecords, setPrivateLibrary } from "../../redux-toolkit/slices/privateLibrarySlice";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import { Card, Col, Row } from "react-bootstrap";
import HTMLFlipBook from "react-pageflip";
import { useDownloadPdfMutation } from "../../redux-toolkit/services/pdfService";

// Set the workerSrc to the local worker script
GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

// First, define proper types for your thumbnails
type ThumbnailState = {
    url: string;
    loading: boolean;
    error?: boolean;
};

type ThumbnailsMap = {
    [key: string]: ThumbnailState;
};

type TextItem = {
    str: string;
    width: number;
    height: number;
    transform: number[];
};

type PageData = {
    image: string;
    text: string;
    textItems: TextItem[];
    viewport: {
        width: number;
        height: number;
    };
};

type Props = {};
const PrivateLibrary = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;
    const flipBookRef = useRef<any>(null); // Ref to control the flipbook
    const inputRef = useRef<HTMLInputElement>(null);
    const canvasRefs = useRef<(HTMLCanvasElement | null)[]>([]);

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [thumbnails, setThumbnails] = useState<ThumbnailsMap>({});
    const [showPdfViewer, setShowPdfViewer] = useState(false); // for PDF viewer
    const [selectedPdf, setSelectedPdf] = useState<any>(null); // for selected PDF
    const [pagesData, setPagesData] = useState<PageData[]>([]);
    const [zoomLevel, setZoomLevel] = useState(1); // Zoom level (1 = 100%)
    const [searchQuery, setSearchQuery] = useState(""); // for search query
    const [searchResults, setSearchResults] = useState<number[]>([]); // Pages with search matches
    const [currentSearchIndex, setCurrentSearchIndex] = useState(-1); // Current match index
    const [isMaximized, setIsMaximized] = useState(false); // for maximize/minimize
    const [isLoadingPages, setIsLoadingPages] = useState(false); // New state for loading
    const [isFlipBookReady, setIsFlipBookReady] = useState(false);
    const [currentFlipPage, setCurrentFlipPage] = useState(0); // Track current page

    const [baseWidth, setBaseWidth] = useState(1000);
    const [baseHeight, setBaseHeight] = useState(1000);

    //getMutations
    const [getLibraryCategories, libraryCategoriesResponse] = useGetAllLibraryCategoriesMutation();
    const [getPrivateLiraryByCatId, privateLibraryByCatIdResponse] = useGetLibraryByCategoryIdMutation();

    //search
    const [getLibraryCategoriesWithSearch, getLibraryCategoriesWithSearchResponse] = useGetAllLibraryCategoriesWithSearchMutation();

    //delete Mutation
    const [deleteLibraryCategory, deleteLibraryCategoryResponse] = useDeleteLibraryCategoryByIdMutation();
    const [deletePrivateLibrary, deletePrivateLibraryResponse] = useDeletePdfMutation();

    //total Records
    const totalLibraryCategories: any = useAppSelector(getLibraryCategoriesTotalRecords);
    const totalPrivateLibrary: any = useAppSelector(getPrivateLibraryTotalRecords);

    //selector
    const allLibraryCategories: any = useAppSelector(getLibraryCategoriesDetails);
    const allPrivateLirary: any = useAppSelector(getPrivateLibraryDetails);

    console.log(allPrivateLirary)

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.LIBRARY_CATEGORY:
                setReportName(REPORT_NAME.LIBRARY_CATEGORY)
                break;
            case REPORT_PATH.LIBRARY:
                setReportName(REPORT_NAME.LIBRARY)
                break;
            default:
        }
    }, [params.reportType]);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-primary" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.LIBRARY_CATEGORY && LIBRARY_CATEGORY_COLUMN) {
            LIBRARY_CATEGORY_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.LIBRARY_CATEGORY) {
            getLibraryCategories({
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.LIBRARY) {
            const categoryId = params?.categoryId; // fetch from route param
            if (categoryId) {
                getPrivateLiraryByCatId({
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                    libraryCategoryId: params.categoryId, // 🟡 IMPORTANT
                });
            }
        }
    }, [reportName, params.categoryId]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.LIBRARY_CATEGORY) {
                getLibraryCategories({
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.LIBRARY) {
                const categoryId = params?.categoryId; // fetch from route param
                if (categoryId) {
                    getPrivateLiraryByCatId({
                        page: currentpage - 1,
                        size: pageSize,
                        sort: "id",
                        libraryCategoryId: categoryId, // 🟡 IMPORTANT
                    });
                }
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.LIBRARY_CATEGORY) {
            getLibraryCategories({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.LIBRARY) {
            const categoryId = params?.categoryId; // fetch from route param
            if (categoryId) {
                getPrivateLiraryByCatId({
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                    libraryCategoryId: categoryId, // 🟡 IMPORTANT
                });
            }
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    //delete..........
    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.LIBRARY_CATEGORY) {
            deleteLibraryCategory({
                id: record.id,
            });
        } else if (reportName === REPORT_NAME.LIBRARY) {
            deletePrivateLibrary({
                id: record.id,
            });
        }
    };

    const handleSearch = (event: any) => {
        // console.log((event.target.value).length)
        if (reportName === REPORT_NAME.LIBRARY_CATEGORY) {
            getLibraryCategoriesWithSearch({
                token: token,
                payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };

    // Function to generate thumbnail from PDF data
    const generateThumbnail = useCallback(async (pdfData: Uint8Array | number[] | string, id: string) => {
        try {
            // Initialize thumbnail state
            setThumbnails(prev => ({
                ...prev,
                [id]: { url: '', loading: true, error: false }
            }));

            // Convert data if needed
            let data: Uint8Array;
            if (typeof pdfData === 'string') {
                // Handle base64 string
                const binaryString = atob(pdfData);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                data = bytes;
            } else if (Array.isArray(pdfData)) {
                // Handle number array
                data = new Uint8Array(pdfData);
            } else {
                // Assume it's already Uint8Array
                data = pdfData;
            }

            const loadingTask = getDocument({ data });
            const pdf = await loadingTask.promise;

            if (pdf.numPages < 1) throw new Error('PDF has no pages');

            const page = await pdf.getPage(1);
            const viewport = page.getViewport({ scale: 0.5 });

            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            if (!context) throw new Error('Could not get canvas context');

            canvas.height = viewport.height;
            canvas.width = viewport.width;

            await page.render({
                canvasContext: context,
                viewport
            }).promise;

            const thumbnailUrl = canvas.toDataURL('image/jpeg', 0.7);

            setThumbnails(prev => ({
                ...prev,
                [id]: { url: thumbnailUrl, loading: false, error: false }
            }));
        } catch (error) {
            console.error('Error generating thumbnail for PDF', id, error);
            setThumbnails(prev => ({
                ...prev,
                [id]: { url: '', loading: false, error: true }
            }));
        }
    }, []);

    // Handle PDF viewing with proper typing
    // const handleViewPdf = (item: { fileData: Uint8Array | number[] | string, title?: string }) => {
    const handleViewPdf = async (item: any) => {
        console.log("item", item);

        try {
            // Validate item.fileData
            if (!item || !item.fileData) {
                throw new Error("PDF file data is missing or undefined.");
            }

            // Debug the type and content of fileData
            console.log("item.fileData type:", typeof item.fileData);
            console.log("item.fileData value:", item.fileData);

            setIsLoadingPages(true);
            setSelectedPdf(item);
            setShowPdfViewer(true);

            // Convert fileData to Uint8Array
            let pdfData: Uint8Array;
            if (typeof item.fileData === 'string') {
                // Handle base64 string
                try {
                    const binaryString = atob(item.fileData);
                    pdfData = new Uint8Array(binaryString.length);
                    for (let i = 0; i < binaryString.length; i++) {
                        pdfData[i] = binaryString.charCodeAt(i);
                    }
                } catch (error: any) {
                    throw new Error("Failed to decode base64 string: " + error.message);
                }
            } else if (Array.isArray(item.fileData)) {
                // Handle number array
                pdfData = new Uint8Array(item.fileData);
            } else if (item.fileData instanceof Uint8Array) {
                // Already a Uint8Array
                pdfData = item.fileData;
            } else {
                throw new Error("Unsupported fileData format: " + typeof item.fileData);
            }

            // Debug the converted pdfData
            console.log("pdfData length:", pdfData.length);
            console.log("pdfData sample:", pdfData.slice(0, 10)); // First 10 bytes for debugging

            // Load PDF directly from the binary data
            const loadingTask = getDocument({
                data: pdfData,
                disableAutoFetch: true,
                disableStream: true
            });

            const pdf = await loadingTask.promise;
            const numPages = pdf.numPages;
            const pages: PageData[] = [];

            const scale = 1.0;

            for (let i = 1; i <= numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale });

                if (i === 1) {
                    setBaseWidth(viewport.width);
                    setBaseHeight(viewport.height);
                }

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                await page.render({
                    canvasContext: context!,
                    viewport,
                }).promise;

                const image = canvas.toDataURL("image/png");

                const textContent = await page.getTextContent();
                const pageText = textContent.items
                    .map((item: any) => item.str || "")
                    .join(" ")
                    .trim();

                const textItems: TextItem[] = textContent.items
                    .filter((item: any) => item.str && item.str.trim())
                    .map((item: any) => ({
                        str: item.str.toLowerCase().trim(),
                        width: item.width * scale,
                        height: item.height * scale,
                        transform: item.transform.map((val: number) => val * scale),
                    }));

                pages.push({
                    image,
                    text: pageText.toLowerCase(),
                    textItems,
                    viewport: {
                        width: viewport.width,
                        height: viewport.height,
                    },
                });
            }

            setPagesData(pages);
            setIsLoadingPages(false);
        } catch (error: any) {
            console.error("Error loading PDF:", error);
            setIsLoadingPages(false);
            alertMessage(`Failed to load PDF: ${error.message}`, "error");
            setShowPdfViewer(false);
        }
    };

    // Generate thumbnails when private library data changes
    useEffect(() => {
        if (reportName === REPORT_NAME.LIBRARY && allPrivateLirary) {
            allPrivateLirary.forEach((item: any) => {
                if (item.fileData && !thumbnails[item.id]) {
                    generateThumbnail(item.fileData, item.id);
                }
            });
        }
    }, [allPrivateLirary, reportName, generateThumbnail, thumbnails]);

    const renderLibraryTiles = () => {
        return (
            <div className="p-4">
                <Row xs={1} sm={2} md={3} lg={4} xl={5} className="g-4">
                    {dataSource.map((item: any) => {
                        const thumbnail = thumbnails[item.id] || { loading: true, error: false };

                        return (
                            <Col key={item.id}>
                                <Card className="h-100">
                                    <div style={{
                                        height: '200px',
                                        backgroundColor: '#f8f9fa',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        {thumbnail.loading ? (
                                            <div className="text-center">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <p className="mt-2 small text-muted">Generating thumbnail...</p>
                                            </div>
                                        ) : thumbnail.error ? (
                                            <div className="text-center text-danger">
                                                <BsFileEarmarkPdf size={48} />
                                                <p className="mt-2 small">Thumbnail failed</p>
                                            </div>
                                        ) : (
                                            <Card.Img
                                                variant="top"
                                                src={thumbnail.url} // Now using the url property
                                                style={{
                                                    objectFit: 'contain',
                                                    height: '100%',
                                                    width: '100%'
                                                }}
                                                onError={() => {
                                                    setThumbnails(prev => ({
                                                        ...prev,
                                                        [item.id]: { ...prev[item.id], error: true }
                                                    }));
                                                }}
                                            />
                                        )}
                                    </div>
                                    <Card.Body>
                                        <Card.Title className="text-truncate">{item.fileName || 'Untitled'}</Card.Title>
                                        {/* <Card.Text className="text-muted small">
                                            {item.description || 'No description'}
                                        </Card.Text> */}
                                    </Card.Body>
                                    <Card.Footer className="d-flex justify-content-between">
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={() => handleViewPdf(item)}
                                        >
                                            View
                                        </Button>
                                        {localUserObj.userType === USER_TYPE.ADMIN && (
                                            <div className="d-flex gap-2">
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() => onDeleteData(item)}
                                                >
                                                    <BsTrash />
                                                </Button>
                                            </div>
                                        )}
                                    </Card.Footer>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        );
    };

    useEffect(() => {
        if (libraryCategoriesResponse.isSuccess) {
            dispatch(setLibraryCategories(libraryCategoriesResponse));
        } else if (libraryCategoriesResponse.isError) {
            let response: any = libraryCategoriesResponse.error;
            alertMessage(response, "error");
        }
    }, [libraryCategoriesResponse.isSuccess, libraryCategoriesResponse.isError]);

    useEffect(() => {
        if (getLibraryCategoriesWithSearchResponse.isSuccess) {
            dispatch(setLibraryCategoriesBySearch(getLibraryCategoriesWithSearchResponse));
        } else if (getLibraryCategoriesWithSearchResponse.isError) {
            let response: any = getLibraryCategoriesWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getLibraryCategoriesWithSearchResponse.isSuccess, getLibraryCategoriesWithSearchResponse.isError]);

    useEffect(() => {
        if (deleteLibraryCategoryResponse.isSuccess) {
            if (deleteLibraryCategoryResponse.data?.isActive) {
                alertMessage("Library Category enable successfully", "success");
            } else {
                alertMessage("Library Category deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteLibraryCategoryResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteLibraryCategoryResponse.isSuccess, deleteLibraryCategoryResponse.isError]);

    //data
    useEffect(() => {
        if (allPrivateLirary && reportName === REPORT_NAME.LIBRARY) {
            setDatasource(allPrivateLirary);
        }
    }, [allPrivateLirary]);


    useEffect(() => {
        if (privateLibraryByCatIdResponse.isSuccess) {
            dispatch(setPrivateLibrary(privateLibraryByCatIdResponse));
        } else if (privateLibraryByCatIdResponse.isError) {
            let response: any = privateLibraryByCatIdResponse.error;
            alertMessage(response, "error");
        }
    }, [privateLibraryByCatIdResponse.isSuccess, privateLibraryByCatIdResponse.isError]);

    useEffect(() => {
        if (deletePrivateLibraryResponse.isSuccess) {
            if (deletePrivateLibraryResponse.data?.isActive) {
                alertMessage("Private Library Record enable successfully", "success");
            } else {
                alertMessage("Private Library Record deleted successfully", "success");
            }
            setCall("Y");
        } else if (deletePrivateLibraryResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deletePrivateLibraryResponse.isSuccess, deletePrivateLibraryResponse.isError]);

    //data
    useEffect(() => {
        if (allLibraryCategories && reportName === REPORT_NAME.LIBRARY_CATEGORY) {
            setDatasource(allLibraryCategories);
        }
    }, [allLibraryCategories]);

    const getFlipbookDimensions = useCallback(() => {
        if (isMaximized) {
            return {
                width: (window.innerWidth - 40) * zoomLevel,
                height: (window.innerHeight - 150) * zoomLevel,
            };
        }
        return {
            width: (baseWidth + 600) * zoomLevel,
            height: (baseHeight + 600) * zoomLevel,
        };
    }, [baseWidth, baseHeight, zoomLevel]);

    // Update highlights when search results, query, or zoom changes
    useEffect(() => {
        canvasRefs.current.forEach((canvas, index) => {
            if (canvas) {
                const ctx = canvas.getContext("2d");
                if (ctx) {
                    // Clear the canvas
                    ctx.clearRect(0, 0, canvas.width, canvas.height);

                    if (searchResults.includes(index) && searchQuery && pagesData.length > 0) {
                        const pageData = pagesData[index];
                        const { width, height } = pageData.viewport;

                        // Calculate scaling factors
                        const scaleX = (baseWidth * zoomLevel) / width;
                        const scaleY = (baseHeight * zoomLevel) / height;

                        const query = searchQuery.toLowerCase().trim();
                        console.log(`Processing highlights for page ${index}, query: "${query}"`);
                        console.log(`Page ${index} text items:`, pageData.textItems);

                        let hasHighlighted = false;
                        pageData.textItems.forEach((item, itemIndex) => {
                            console.log(`Checking text item ${itemIndex}: "${item.str}"`);
                            if (item.str.includes(query)) {
                                const x = item.transform[4] * scaleX;
                                // const y = (height - item.transform[5]) * scaleY;
                                const y = (height - item.transform[5]) * scaleY - (item.height / 2);
                                const itemWidth = item.width * scaleX;
                                const itemHeight = item.height * scaleY;

                                ctx.fillStyle =
                                    currentSearchIndex === searchResults.indexOf(index)
                                        ? "rgba(255, 0, 0, 0.5)" // Red for current match
                                        : "rgba(255, 255, 0, 0.5)"; // Yellow for other matches
                                ctx.fillRect(x, y, itemWidth, itemHeight);

                                console.log(`Highlighting on page ${index}:`, {
                                    query,
                                    str: item.str,
                                    x,
                                    y: y - itemHeight,
                                    width: itemWidth,
                                    height: itemHeight,
                                    color: ctx.fillStyle,
                                });
                                hasHighlighted = true;
                                // // Fallback: If no text items match, highlight the entire page
                                // if (!hasHighlighted && pageData.text.includes(query)) {
                                //     console.log(`No matching text items found on page ${index}, applying fallback highlight`);
                                //     ctx.fillStyle =
                                //         currentSearchIndex === searchResults.indexOf(index)
                                //             ? "rgba(255, 0, 0, 0.2)"
                                //             : "rgba(255, 255, 0, 0.2)";
                                //     ctx.fillRect(0, 0, baseWidth * zoomLevel, baseHeight * zoomLevel);
                                // }
                            }
                        });
                    }
                }
            }
        });
    }, [searchResults, searchQuery, pagesData, currentSearchIndex, zoomLevel]);


    // Check if flipBookRef is ready after pagesData is loaded
    useEffect(() => {
        if (pagesData.length > 0 && flipBookRef.current) {
            let attempts = 0;
            const maxAttempts = 50; // 5 seconds (50 * 100ms)

            const checkFlipBookReady = () => {
                attempts++;
                const pageFlipInstance = flipBookRef.current.pageFlip();
                if (pageFlipInstance && typeof pageFlipInstance.flip === "function") {
                    console.log("FlipBook is ready after", attempts, "attempts!");
                    setIsFlipBookReady(true);
                } else if (attempts >= maxAttempts) {
                    console.warn("Max attempts reached. Using fallback navigation.");
                    setIsFlipBookReady(true); // Allow fallback navigation
                } else {
                    console.log("FlipBook not ready yet, attempt", attempts);
                    setTimeout(checkFlipBookReady, 100); // Retry after 100ms
                }
            };

            console.log("Starting FlipBook readiness check...");
            checkFlipBookReady();
        }

        // Cleanup on unmount
        return () => {
            setIsFlipBookReady(false);
        };
    }, [pagesData]);

    // Force FlipBook to update when zoomLevel changes
    useEffect(() => {
        if (flipBookRef.current && isFlipBookReady) {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.updateFrom === "function") {
                console.log("Updating FlipBook dimensions for zoomLevel:", zoomLevel);
                pageFlipInstance.update();
            }
        }
    }, [zoomLevel, isFlipBookReady]);

    // Search functionality
    const handleSearchInPdf = () => {
        if (!searchQuery) {
            setSearchResults([]);
            setCurrentSearchIndex(-1);
            alertMessage("Please enter a search term.", "warning");
            return;
        }

        if (isLoadingPages) {
            alertMessage("Please wait, PDF pages are still loading.", "warning");
            return;
        }

        if (pagesData.length === 0) {
            alertMessage("PDF pages are not loaded yet.", "error");
            return;
        }

        if (!isFlipBookReady) {
            alertMessage("FlipBook is not ready yet. Please wait.", "warning");
            return;
        }

        const query = searchQuery.toLowerCase().trim();
        console.log("Searching for:", query);
        console.log("Pages data:", pagesData);

        const results: number[] = [];
        pagesData.forEach((page, index) => {
            if (page.text.includes(query)) {
                results.push(index);
            }
        });

        console.log("Search results (page indices):", results);

        if (results.length === 0) {
            alertMessage("No matches found.", "info");
        } else {
            alertMessage(`${results.length} match(es) found.`, "success");
        }

        setSearchResults(results);
        setCurrentSearchIndex(results.length > 0 ? 0 : -1);

        if (results.length > 0) {
            const pageToJump = results[0];
            console.log("Jumping to page:", pageToJump);
            if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
                const pageFlipInstance = flipBookRef.current.pageFlip();
                if (pageFlipInstance && typeof pageFlipInstance.flip === "function") {
                    pageFlipInstance.flip(pageToJump);
                    setCurrentFlipPage(pageToJump);
                } else {
                    // Fallback: Update startPage as a fallback navigation method
                    console.warn("PageFlip instance not ready, using fallback navigation");
                    setCurrentFlipPage(pageToJump);
                }
            } else {
                console.error("Flipbook ref not ready or pageFlip not available");
                alertMessage("Flipbook not ready. Please try again.", "error");
            }
        }
    };

    // Navigate to next/previous search result
    const handleNextSearchResult = () => {
        if (searchResults.length === 0) return;
        const nextIndex = (currentSearchIndex + 1) % searchResults.length;
        setCurrentSearchIndex(nextIndex);
        const pageToJump = searchResults[nextIndex];
        console.log("Next search result, jumping to page:", pageToJump);
        if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.flip === "function") {
                pageFlipInstance.flip(pageToJump);
                setCurrentFlipPage(pageToJump);
            } else {
                // Fallback
                setCurrentFlipPage(pageToJump);
            }
        }
    };

    const handlePrevSearchResult = () => {
        if (searchResults.length === 0) return;
        const prevIndex = (currentSearchIndex - 1 + searchResults.length) % searchResults.length;
        setCurrentSearchIndex(prevIndex);
        const pageToJump = searchResults[prevIndex];
        console.log("Previous search result, jumping to page:", pageToJump);
        if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.flip === "function") {
                pageFlipInstance.flip(pageToJump);
                setCurrentFlipPage(pageToJump);
            } else {
                // Fallback
                setCurrentFlipPage(pageToJump);
            }
        }
    };

    // Navigation functions for the flipbook
    const handlePrevPage = () => {
        if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.flipPrev === "function") {
                pageFlipInstance.flipPrev();
            } else {
                // Fallback
                if (currentFlipPage > 0) {
                    setCurrentFlipPage(currentFlipPage - 1);
                }
            }
        }
    };

    const handleNextPage = () => {
        if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.flipNext === "function") {
                pageFlipInstance.flipNext();
            } else {
                // Fallback
                if (currentFlipPage < pagesData.length - 1) {
                    setCurrentFlipPage(currentFlipPage + 1);
                }
            }
        }
    };

    const handleZoomIn = () => {
        const newZoom = Math.min(zoomLevel + 0.25, 3);
        setZoomLevel(newZoom);
        console.log("Zooming in, new zoom level:", newZoom);
    };

    const handleZoomOut = () => {
        const newZoom = Math.max(zoomLevel - 0.25, 0.5);
        setZoomLevel(newZoom);
        console.log("Zooming out, new zoom level:", newZoom);
    };

    const toggleMaximize = () => {
        setIsMaximized((prev) => !prev);
    };

    // Prevent screenshot and print
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                setShowPdfViewer(false);
            }
        };

        const handleBeforePrint = () => {
            setShowPdfViewer(false);
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("beforeprint", handleBeforePrint);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("beforeprint", handleBeforePrint);
        };
    }, []);

    const closePdfViewer = () => {
        setShowPdfViewer(false);
        setSelectedPdf(null);
        setPagesData([]);
        setSearchQuery("");
        setSearchResults([]);
        setCurrentSearchIndex(-1);
        setIsMaximized(false);
        setIsLoadingPages(false);
        setIsFlipBookReady(false);
        setZoomLevel(1);
    };


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-cm-active-primary1"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    {reportName !== REPORT_NAME.LIBRARY && (
                        <div className="d-flex flex-column">
                            <div className="input-group px-2 mt-1">
                                <Form.Control
                                    type="search"
                                    placeholder="Search"
                                    className="border-0 bg-cm-light-primary1"
                                    aria-label="Search"
                                    onChange={handleSearch}
                                />
                                <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                    <span className="input-group-text bg-cm-light-primary1 border-0">
                                        {/* <img src={gear} alt="" /> */}
                                        <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    {reportName === REPORT_NAME.LIBRARY && localUserObj?.userType === USER_TYPE.ADMIN && (
                        <div className="d-flex px-2 align-items-center mt-1">
                            <Button
                                variant="primary"
                                className="d-flex align-items-center me-0 text-nowrap"
                                onClick={handleShow}
                            >
                                <>
                                    <BsUpload className="me-2" />
                                    Upload
                                </>

                            </Button>
                        </div>
                    )}
                    {reportName !== REPORT_NAME.LIBRARY && (
                        <div className="d-flex px-2 align-items-center mt-1">
                            <Button
                                variant="primary"
                                className="d-flex align-items-center me-0 text-nowrap"
                                onClick={handleShow}
                            >
                                <>
                                    <BsPlus className="me-2" />
                                    Add
                                </>
                            </Button>
                        </div>
                    )}
                    {libraryCategoriesResponse.isLoading ||
                        getLibraryCategoriesWithSearchResponse.isLoading ||
                        deleteLibraryCategoryResponse.isLoading ? (
                        <Loading />
                    ) : (
                        ""
                    )}
                    {show && (
                        <PrivateLibraryData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                        />
                    )}
                </div>
            </div>
            {reportName === REPORT_NAME.LIBRARY ? renderLibraryTiles() : (
                <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                    <Table
                        bordered={true}
                        rowKey={"id"}
                        scroll={{ x: 'max-content' }}
                        tableLayout="fixed"
                        pagination={{
                            total: (() => {
                                switch (reportName) {
                                    case REPORT_NAME.LIBRARY_CATEGORY:
                                        return totalLibraryCategories;
                                    default:
                                        return dataSource.length;
                                }
                            })(),
                            responsive: true,
                            current: currentpage,
                            // showSizeChanger: true,  
                            pageSizeOptions: [10, 20, 30],
                            onChange: (page, pageSize) => {
                                paginationChange(page, pageSize);
                            },
                            pageSize: pageSize,
                        }}
                        columns={columData}
                        dataSource={dataSource}
                    />
                </div>
            )}
            {/* PDF Viewer Modal */}
            {showPdfViewer && (
                <div
                    className="modal show d-block"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                    onClick={closePdfViewer}
                >
                    <div
                        className="modal-dialog"
                        style={{
                            margin: "auto",
                            maxWidth: "100%",
                            width: "100%",
                            height: "100vh",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-content" style={{ height: "100vh" }}>
                            <div className="modal-header">
                                <div className="d-flex align-items-center">
                                    <div className="input-group me-2" style={{ width: "300px" }}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search in PDF..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") handleSearchInPdf();
                                            }}
                                            disabled={isLoadingPages}
                                        />
                                        <Button
                                            variant="outline-primary"
                                            onClick={handleSearchInPdf}
                                            disabled={isLoadingPages}
                                        >
                                            Search
                                        </Button>
                                    </div>
                                    {searchResults.length > 0 && (
                                        <div className="d-flex align-items-center me-2">
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={handlePrevSearchResult}
                                                disabled={currentSearchIndex === -1}
                                            >
                                                Prev
                                            </Button>
                                            <span className="mx-2">
                                                {currentSearchIndex + 1} of {searchResults.length}
                                            </span>
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={handleNextSearchResult}
                                                disabled={currentSearchIndex === -1}
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    )}
                                    <div className="d-flex align-items-center me-2">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={handleZoomOut}
                                            disabled={zoomLevel <= 0.5}
                                        >
                                            <BsZoomOut size={16} />
                                        </Button>
                                        <span className="mx-2">{Math.round(zoomLevel * 100)}%</span>
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={handleZoomIn}
                                            disabled={zoomLevel >= 3}
                                        >
                                            <BsZoomIn size={16} />
                                        </Button>
                                    </div>
                                    <Button
                                        variant="outline-secondary"
                                        className="me-2"
                                        onClick={toggleMaximize}
                                    >
                                        {isMaximized ? "Minimize" : "Maximize"}
                                    </Button>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={closePdfViewer}
                                ></button>
                            </div>
                            <div
                                className="modal-body p-0"
                                style={{
                                    // height: "calc(100vh - 100px)",
                                    height: `${baseHeight * zoomLevel}px`,
                                    overflowY: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                }}
                            >
                                {isLoadingPages ? (
                                    <div>Loading PDF pages...</div>
                                ) : pagesData.length > 0 ? (
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <HTMLFlipBook
                                            width={getFlipbookDimensions().width}
                                            height={getFlipbookDimensions().height}
                                            size="fixed"
                                            minWidth={getFlipbookDimensions().width}
                                            maxWidth={getFlipbookDimensions().width}
                                            minHeight={getFlipbookDimensions().height}
                                            maxHeight={getFlipbookDimensions().height}
                                            drawShadow={true}
                                            flippingTime={1000}
                                            usePortrait={true}
                                            startPage={currentFlipPage}
                                            className="flip-book"
                                            style={{
                                                flex: "none",
                                                margin: "0 auto",
                                                background: "#eee",
                                                border: "1px solid #ccc"
                                            }}
                                            ref={flipBookRef}
                                            useMouseEvents={true}
                                            onFlip={(e: any) => {
                                                setCurrentFlipPage(e.data);
                                            }}
                                            onInit={(data: any) => {
                                                console.log("FlipBook onInit fired!", data);
                                                const pageFlipInstance = flipBookRef.current.pageFlip();
                                                console.log("PageFlip instance in onInit:", pageFlipInstance);
                                            }}
                                            startZIndex={0}
                                            autoSize={false}
                                            maxShadowOpacity={0}
                                            showCover={false}
                                            mobileScrollSupport={false}
                                            clickEventForward={false}
                                            swipeDistance={0}
                                            showPageCorners={false}
                                            disableFlipByClick={false}
                                        >
                                            {pagesData.map((page, index) => (
                                                <div className="demoPage" key={index}
                                                    style={{
                                                        width: `${baseWidth}px`,
                                                        height: `${baseHeight}px`,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        overflow: "hidden", // prevents spill
                                                        position: "relative",
                                                    }}>
                                                    <div
                                                        style={{
                                                            width: `${baseWidth}px`,
                                                            height: `${baseHeight}px`,
                                                            transform: `scale(${zoomLevel})`,
                                                            transformOrigin: "top left",
                                                            position: "relative",
                                                        }}
                                                    >
                                                        <img
                                                            src={page.image}
                                                            alt={`Page ${index + 1}`}
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "contain",
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                zIndex: 1,
                                                                // width: `${baseWidth * zoomLevel}px`,
                                                                // height: `${baseHeight * zoomLevel}px`,
                                                                // objectFit: "contain",
                                                                // display: "block",
                                                                // marginTop: "0px"
                                                            }}
                                                        />
                                                        {searchResults.includes(index) && searchQuery && (
                                                            <canvas
                                                                width={baseWidth}
                                                                height={baseHeight}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: 0,
                                                                    // width: `${getFlipbookDimensions().width}px`,
                                                                    // height: `${getFlipbookDimensions().height}px`,
                                                                    pointerEvents: "none",
                                                                }}
                                                                ref={(el) => (canvasRefs.current[index] = el)}
                                                            />
                                                        )}
                                                        <canvas
                                                            width={baseWidth}
                                                            height={baseHeight}
                                                            style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                // width: `${baseWidth * zoomLevel}px`,
                                                                // height: `${baseHeight * zoomLevel}px`,
                                                                pointerEvents: "none",
                                                                opacity: 0.3,
                                                            }}
                                                            ref={(canvas) => {
                                                                if (canvas) {
                                                                    const ctx = canvas.getContext("2d");
                                                                    if (ctx) {
                                                                        ctx.fillStyle = "#3997ff";
                                                                        ctx.font = `${20 * zoomLevel}px Arial`;
                                                                        for (let x = 0; x < canvas.width; x += 100 * zoomLevel) {
                                                                            for (let y = 0; y < canvas.height; y += 100 * zoomLevel) {
                                                                                ctx.fillText("Kalki Agent", x, y);
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </HTMLFlipBook>
                                        <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                                            <Button
                                                variant="primary"
                                                onClick={handlePrevPage}
                                                disabled={currentFlipPage === 0}
                                            >
                                                Previous
                                            </Button>
                                            <span className="mt-1">
                                                Page {currentFlipPage + 1} of {pagesData.length}
                                            </span>
                                            <Button
                                                variant="primary"
                                                onClick={handleNextPage}
                                                disabled={currentFlipPage >= pagesData.length - 1}
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                ) : (
                                    <div>No pages loaded.</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={closePdfViewer}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default PrivateLibrary;